import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import items from "../../utils/itemData";
import Button from "../Button";
import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import * as SC from "../MasterCss";
import { SoundContext } from "../../context/SoundContext";
import {getValidItemsForGameType} from "../../utils/gameUtils";
import { getItemName, getItemFact, getBinName } from "../../utils/i18nHelpers"; 

const FailBox = styled.div`
  background-color: rgba(235, 16, 16, 0.7);
  padding: 3em;
  width: 100vw;
  height: 100vh;
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1500;
  padding: 0px;
`;

const FailModal = props => {
  const { t } = useTranslation();
  const { playSound } = useContext(SoundContext);

  useEffect(() => {
    playSound("error"); // plays error sound
  }, []);

  const navigate = useNavigate();
  const handleClose = () => {
    props.setFailModal(false);
    props.pickNextItem();
    if (props.badCount === 3) {
      navigate(`/results?game=${props.game}&type=${props.gameType}`);
    }
  };

  const item = props.item;

  const itemName = getItemName(t, item);
  const itemFact = getItemFact(t, item);
  const binName = getBinName(t, item.bin);

  const isSpecialBin = ['yard waste', 'special programs'].includes(item.bin.toLowerCase());
  const messageKey = isSpecialBin ? 'failModal.messageWithoutBin' : 'failModal.messageWithBin'
  return (
    <FailBox id="fail" onClick={handleClose}>
      
      <SC.ModalHeader>{t('failModal.title')}</SC.ModalHeader>
      <SC.ModalHeader>
        {t(messageKey, {
          itemName,
          binName
        })}
      </SC.ModalHeader>
      <SC.BadgeBox>
        <SC.MessageBox expand>
        <SC.MessageImage alt={itemName} src={item.src} />
        <SC.BoxMessage>{itemFact}</SC.BoxMessage>
        </SC.MessageBox>
      </SC.BadgeBox>
      <Button primary handleClick={handleClose} label={t('failModal.okButton')} />
    </FailBox>
  );
};

export default FailModal;
